import { secondAxios } from "../../../../../api/axios";

export async function getPipingTable(tableName) {
  if (!tableName) {
    throw new Error("tableName is required");
  }

  const safeTableName = `"${String(tableName).replace(/"/g, '""')}"`;

  const res = await secondAxios.post(`/sqlite-db/query`, {
    dbName: "piping",
    sql: `SELECT * FROM ${safeTableName}`,
  });

  return res.data;
}